import { Injectable } from '@angular/core';
import { validate, clean, format } from 'rut.js';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  verifyRut(rut: string): { formattedRut: string; isValid: boolean } {
    const cleanedRut = clean(rut);
    const formattedRut = format(cleanedRut, { dots: false });
    const isValid = validate(cleanedRut);
    return { formattedRut, isValid };
  }


}
